import axios from 'axios'
import { API_PATHS } from 'config/routes'
import { useDispatch } from 'react-redux'
import { getUrlParamsFromJson } from 'utils/helpers'
import { destroyUser, getLanguage, getUserinfo } from 'utils/localStorage'

export const loginApi = async userInfo => {
	try {
		const { data, status } = await axios.post(API_PATHS.login, userInfo)
		if (status !== 200 || data?.success === false) {
			throw new Error(data.message || "Can't login!")
		}

		return data
	} catch (e) {
		console.error(e.message)
	}
}
export const ShopOTPApi = async shopOTP => {
	try {
		const { data, status } = await axios.post(API_PATHS.shopOTP, shopOTP)
		if (status !== 200 || data?.success === false) {
			throw new Error(data.message || "Can't send OTP!")
		}

		return data
	} catch (e) {
		console.error(e.message)
		return e
	}
}
export const buyPackageApi = async buyPackage => {
	try {
		const { data, status } = await axios.post(API_PATHS.buyPackage, buyPackage)
		if (status !== 200 || data?.success === false) {
			throw new Error(data.message || "Can't buy package!")
		}

		return data
	} catch (e) {
		console.error(e.message)
		return e
	}
}
export const updateSettingApi = async updateSetting => {
	try {
		const { data, status } = await axios.post(
			API_PATHS.updateSetting,
			updateSetting,
		)
		if (status !== 200 || data?.success === false) {
			throw new Error(data.message || "Can't update setting!")
		}

		return data
	} catch (e) {
		console.error(e.message)
		return e
	}
}
export const changePassApi = async changePass => {
	try {
		const { data, status } = await axios.post(API_PATHS.changePass, changePass)
		if (status !== 200 || data?.success === false) {
			throw new Error(data.message || "Can't buy package!")
		}

		return data
	} catch (e) {
		console.error(e.message)
		return e
	}
}
export const addRewardApi = async addReward => {
	try {
		const { data, status } = await axios.post(API_PATHS.addReward, addReward)
		// if (status !== 200 || data?.success === false) {
		// 	throw new Error(data.message || "Can't add Reward!")
		// }
		return data
	} catch (e) {
		return e

		console.error(e.message)
	}
}

export const loginSMSApi = async userInfo => {
	try {
		const { data, status } = await axios.post(API_PATHS.login, userInfo)
		if (status !== 200 || data?.success === false) {
			throw new Error(data.message || "Can't login by SMS!")
		}

		return data
	} catch (e) {
		console.error(e.message)
	}
}

axios.interceptors.request.use(
	function (config) {
		const user = getUserinfo()
		const language = getLanguage()
		config.headers.Authorization = `Bearer ${user?.accessToken}`
		config.headers.language = language
		return config
	},
	function (error) {
		return Promise.reject(error)
	},
)
export const getListInvitationApi = async ({ queryKey }) => {
	try {
		const [, { offset, limit }] = queryKey
		const params = getUrlParamsFromJson({
			limit,
			offset,
		})
		const { data } = await axios.get(`${API_PATHS.getListInvitation}?${params}`)
		if (parseInt(data.responseCode) !== 200) {
			throw new Error(data.message || "Can't get list invitation!")
		}
		return data.data
	} catch (e) {
		console.error(e.message)
	}
}

export const getUserApi = async () => {
	try {
		if (!getUserinfo()) {
			return null
		}
		const { data } = await axios.get(API_PATHS.getUser)
		if (parseInt(data.responseCode) !== 200) {
			if (getUserinfo()) {
				localStorage.removeItem('isPopupShownPackage_T10-2025')
				localStorage.removeItem('hasShownSubModal')
				destroyUser()
			}
			throw new Error(data.message || "Can't get user info!")
		}
		console.log('user', data.data)

		return data.data
	} catch (e) {
		console.error(e.message)
	}
}
export const getSettingApi = async () => {
	try {
		const { data } = await axios.get(API_PATHS.getSetting)
		if (parseInt(data.responseCode) !== 200) {
			throw new Error(data.message || "Can't get user info!")
		}
		return data.data.htmlContent
	} catch (e) {
		console.error(e.message)
	}
}

export const requestOTP = async isdn => {
	try {
		const { data, status } = await axios.post(API_PATHS.getOTP, isdn)
		if (status !== 200 || data?.success === false) {
			throw new Error(data.errorMessage || "Can't get OTP!")
		}

		return data
	} catch (e) {
		console.error(e.message)
	}
}

export const getFriendApi = async () => {
	try {
		const { data } = await axios.get(API_PATHS.getFriend)
		if (parseInt(data.responseCode) !== 200) {
			throw new Error(data.message || "Can't get friend list!")
		}
		return data.data.friends
	} catch (e) {
		console.error(e.message)
	}
}

export const getUserInfoApi = async () => {
	try {
		const { data } = await axios.get(API_PATHS.getUserInfo)
		if (parseInt(data.responseCode) !== 200) {
			throw new Error(data.message || "Can't get user information!")
		}
		return data.data
	} catch (e) {
		console.error(e.message)
	}
}

export const updateUserInfoApi = async userInfo => {
	try {
		const { data } = await axios.post(API_PATHS.editUserInfo, userInfo)
		if (parseInt(data.responseCode) !== 200) {
			throw new Error(data.message || "Can't update user information!")
		}
		return data
	} catch (e) {
		console.error(e.message)
	}
}
export const acceptInviteFriendApi = async userAccept => {
	try {
		const { data } = await axios.post(API_PATHS.acceptInviteFriend, userAccept)
		if (parseInt(data.responseCode) !== 200) {
			throw new Error(data.message || "Can't accept invite friend!")
		}
		return data
	} catch (e) {
		console.error(e.message)
	}
}

export const getGiftHistApi = async ({ queryKey }) => {
	try {
		const [, { time, offset, limit }] = queryKey
		const { data } = await axios.get(
			`${API_PATHS.getGiftHist}?time=${time}&limit=${limit}&offset=${offset}`,
		)
		if (parseInt(data.responseCode) !== 200) {
			throw new Error(data.message || "Can't get reward history!")
		}
		return data.data.history
	} catch (e) {
		console.error(e.message)
	}
}
